import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from 'mobx-react-lite';
import cls from 'classnames';
import { getFullHueName } from '../../helpers/hueUtils';
import styles from './HueDescription.module.less';
function HueDescription(props) {
    const { hue, className, hueBoxPosition = 'end' } = props;
    return (_jsxs("div", { className: cls(styles.hueDescription, className), style: { flexDirection: hueBoxPosition === 'start' ? 'row' : 'row-reverse' }, children: [_jsx("div", { className: styles.hueColorSquare, style: { backgroundColor: hue.color } }), getFullHueName(hue)] }));
}
export default observer(HueDescription);
